module.exports = __webpack_public_path__ + "db4d366bd2bbf9ac520d4c0651786fa2.MP3";